__turbopack_context__.v({
  "bar": "styles-module__x6tYPG__bar",
  "barTitle": "styles-module__x6tYPG__barTitle",
  "barTitleWrap": "styles-module__x6tYPG__barTitleWrap",
  "imageList": "styles-module__x6tYPG__imageList",
  "item": "styles-module__x6tYPG__item",
  "itemImage": "styles-module__x6tYPG__itemImage",
});
